<template>
  <div
    :class="['ag-cell-link', highLight ? 'highLightCell' : '']"
    @click="handleCellClick"
  >
    <asc-app-link v-if="to" :to="to" class="link">{{ value }}</asc-app-link>
    <a v-else href="#" class="link" @click="handleTextClick">{{ value }}</a>
    <i
      v-if="showIcon"
      aria-hidden="true"
      :class="['v-icon', 'notranslate', 'mdi', iconClass]"
    ></i>
  </div>
</template>
<script>
import AscAppLink from '@/components/atoms/AscAppLink'

export default {
  name: 'AscLinkCell',

  components: {
    AscAppLink,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      default: undefined,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    highLight: {
      type: Boolean,
      default: true,
    },
    iconClass: {
      type: String,
      default: 'mdi-pencil',
    },
  },

  methods: {
    handleCellClick(e) {
      if (!this.to) this.$emit('OnCellClick', e)
    },

    handleTextClick(e) {
      this.$emit('OnTextClick', e)
    },
  },
}
</script>

<style lang="scss">
.ag-cell-link {
  left: 0;
  top: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: inline-block;
  position: absolute;
  padding: 12px;

  .link {
    cursor: pointer;
    text-decoration: none;
    color: $accent-700 !important;

    &:hover {
      text-decoration: underline;
    }
  }

  i.v-icon {
    cursor: pointer;
    color: $accent-700;
    font-size: 15px;

    &.mdi-pencil {
      display: none;
    }

    &.mdi-chevron-right {
      margin-left: 5.3px;
    }

    &.mdi-plus-circle-multiple-outline {
      padding-left: 5px;
    }
  }

  &:hover {
    &.highLightCell {
      background-color: $accent-0;

      .link {
        text-decoration: underline !important;
      }
    }

    i.v-icon {
      &.mdi-pencil {
        position: relative;
        margin-left: 10px;
        display: inline;
      }
    }
  }
}
</style>
